import * as _ from 'lodash';
import { Component, OnInit } from '@angular/core';
import { RouteInfo } from './sidebar.metadata';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { GroupService } from 'app/settings/groups/shared/group.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { RoleService } from 'app/settings/roles/shared/role.service';
import { Role } from 'app/settings/roles/shared/role.model';
import { Group } from 'app/settings/groups/shared/group.model';
import { GlobalService } from 'app/shared/global.service';
import { User } from 'app/users/shared/user.model';
import { environment } from 'environments/environment';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Unit } from 'app/settings/units/shared/unit.model';
import { Building } from 'app/settings/buildings/shared/building.model';
import { UnitService } from 'app/settings/units/shared/unit.service';
import { BuildingService } from 'app/settings/buildings/shared/building.service';
import { SettingService } from 'app/settings/shared/setting.service';
import { Setting } from 'app/settings/shared/setting.model';

declare var $: any;
@Component({
    // moduleId: module.id,
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    public roles: Role[] = [];
    public units: Unit[] = [];
    public buildings: Building[] = [];
    public groups: Group[] = [];
    public loading = false;
    private loaded = false;
    public ROUTES: RouteInfo[] = [];
    public currentUser: User;
    public settings: Setting;

    constructor(private router: Router,
        private titleService: Title,
        private unitService: UnitService,
        private buildingService: BuildingService,
        private roleService: RoleService,
        private groupService: GroupService,
        private globalService: GlobalService,
        private translate: TranslateService,
        private settingService: SettingService,
        private angularFireAuth: AngularFireAuth) {
    }

    ngOnInit() {
        $.getScript('./assets/js/app-sidebar.js');

        this.loadData();
        this.globalService.$currentUser.subscribe((currentUser) => {
            this.currentUser = currentUser;
            if (!this.loaded || this.globalService.currentUserHasChanged) {
                this.globalService.currentUserHasChanged = false;
                this.loadData();
            }
            this.titleService.setTitle(currentUser.appName);
        });
    }

    loadData() {

        if (!this.globalService.currentUser || !this.globalService.currentUser.id) {
            return;
        }

        this.loaded = true;

        const routes = this.ROUTES.filter(menuItem => menuItem);

        const params = new HttpParams();

        this.loading = true;
        this.settingService.getAll(new HttpParams()).subscribe(settings => {
            if (settings.length > 0) {
                this.settings = settings[0];
                this.roleService.getAll(params).subscribe(roles => {
                    this.roles = roles;
                    this.unitService.getAll(params).subscribe(units => {
                        this.units = units;
                        this.buildingService.getAll(params).subscribe(buildings => {
                            this.buildings = buildings;

                            routes.push({
                                path: '/dashboard',
                                title: 'dashboard',
                                icon: 'icon-speedometer', class: '', badge: '', badgeClass: '', isExternalLink: false,
                                submenu: [],
                            });

                            if (this.globalService.currentUser) {
                                routes.push({
                                    path: '/categories',
                                    title: environment.categories ? environment.categories : 'school_info',
                                    icon: 'icon-pin', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                });
                            }

                            if (this.globalService.currentUser && this.globalService.currentUser.role && this.globalService.currentUser.isAdminGlobal) {
                                routes.push({
                                    path: '/users-by-group',
                                    title: 'all_users',
                                    icon: 'icon-users', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                });
                            }

                            if (this.globalService.currentUser && this.globalService.currentUser.can && this.globalService.currentUser.role && this.globalService.currentUser.role.dontShowCategories) { // this.globalService.currentUser.can('dontShowCategories')
                            } else {
                                routes.push({
                                    path: '/classes',
                                    title: environment.groupsName ? environment.groupsName : 'groups',
                                    icon: 'icon-briefcase', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                                    submenu: [],
                                });
                            }

                            routes.push({
                                path: '/messages',
                                title: 'bottombar_messages',
                                icon: 'icon-envelope', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                            });

                            let personalSubMenu = [{
                                path: '/personal/categories',
                                title: 'categories',
                                icon: 'icon-pin', class: '', badge: '',
                                    badgeClass: '', isExternalLink: false, submenu: []
                            }];

                            if (!this.settings.classBookDisabled) {
                                personalSubMenu.push({
                                    path: '/personal/classbook',
                                    title: 'classBook',
                                    icon: 'icon-book-open', class: '', badge: '',
                                        badgeClass: '', isExternalLink: false, submenu: []
                                });
                            }

                            routes.push({
                                path: '/personal',
                                title: 'personal',
                                icon: 'icon-user', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                                submenu: personalSubMenu,
                            });

                            if (this.globalService.currentUser && this.globalService.currentUser.can && this.globalService.currentUser.can('canSeeFormResults')) {
                                routes.push({
                                    path: '/forms',
                                    title: 'form_entries',
                                    icon: 'icon-check', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                });
                            }
                            routes.push({
                                path: '/support',
                                title: 'support',
                                icon: 'icon-bubble', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                            });
                            routes.push({
                                path: '/helps',
                                title: 'help_settings',
                                icon: 'icon-question', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                            });
                            if (this.globalService.currentUser && this.globalService.currentUser.can && this.globalService.currentUser.can('canSeeTemplates')) {
                                routes.push({
                                    path: '/templates',
                                    title: 'templates',
                                    icon: 'icon-doc', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                });
                            }
                            if (this.globalService.currentUser && this.globalService.currentUser.role && this.globalService.currentUser.isAdmin) {
                                const route = {
                                    path: '/settings',
                                    title: 'admin',
                                    icon: 'icon-settings', class: 'has-sub', badge: '', badgeClass: '', isExternalLink: false,
                                    submenu: [
                                        {
                                            path: '/settings/groups',
                                            title: environment.groupsName ? environment.groupsName : 'groups',
                                            icon: 'icon-briefcase', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/units',
                                            title: 'school_units',
                                            icon: 'icon-graduation', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/buildings',
                                            title: 'school_buildings',
                                            icon: 'icon-graduation', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/roles',
                                            title: 'roles',
                                            icon: 'icon-lock', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/notes',
                                            title: 'announcement',
                                            icon: 'icon-fire', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/class-book-templates',
                                            title: 'contact_booklet_reasons',
                                            icon: 'icon-book-open', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/class-book-folders',
                                            title: 'classBook_folders',
                                            icon: 'icon-folder', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/premade-messages',
                                            title: 'premade_messages',
                                            icon: 'icon-envelope-letter', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/users',
                                            title: 'all_users',
                                            icon: 'icon-users', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/users-without-class',
                                            title: 'users_without_classes',
                                            icon: 'icon-users', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/users-children-groups-mismatch',
                                            title: 'children-in-class-without-group',
                                            icon: 'icon-users', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/user-cleaner',
                                            title: 'user-cleaner',
                                            icon: 'icon-trash', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/form-cleaner',
                                            title: 'form-cleaner',
                                            icon: 'icon-trash', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/user-errors',
                                            title: 'user-errors',
                                            icon: 'icon-users', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/user-diagnostics',
                                            title: 'Benutzer-Diagnose',
                                            icon: 'icon-wrench', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }, {
                                            path: '/settings/exports',
                                            title: 'export',
                                            icon: 'icon-cloud-download', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        }
                                    ]
                                };

                                if (this.globalService.currentUser.isAdminGlobal) {

                                    route.submenu.push({
                                        path: '/settings/manage',
                                        title: 'action_settings',
                                        icon: 'icon-settings', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    });
                                    route.submenu.push({
                                        path: '/settings/user-fields',
                                        title: 'additional_fields',
                                        icon: 'icon-settings', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    });
                                    if (environment.firebase.projectId !== 'schule-zuzwil-p28mu9' && environment.firebase.projectId !== 'schule-rorschacherberg-7q45pn1') {
                                        route.submenu.push({
                                            path: '/settings/logs',
                                            title: 'logs',
                                            icon: 'icon-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                        })
                                    }
                                    route.submenu.push({
                                        path: '/settings/imports',
                                        title: 'import',
                                        icon: 'icon-cloud-upload', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    });
                                    route.submenu.push({
                                        path: '/settings/delete-messages',
                                        title: 'Nachrichten löschen',
                                        icon: 'icon-trash', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    });
                                }

                                if (environment.firebase.projectId === 'schule-zuzwil-p28mu9' || environment.firebase.projectId === 'schule-rorschacherberg-7q45pn1') {
                                    route.submenu.push({
                                        path: '/settings/logs',
                                        title: 'logs',
                                        icon: 'icon-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    })
                                }

                                // if (environment.firebase.projectId === 'schoolapp01-7009b' || environment.firebase.projectId === 'school-app-schweiz-19f96') {
                                    route.submenu.push({
                                        path: '/settings/helps',
                                        title: 'help_settings',
                                        icon: 'icon-question', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    })
                                // }

                                _.forEach(this.roles, (role) => {
                                    route.submenu.push({
                                        path: '/settings/usersbyrole/' + role.id + '/users',
                                        title: role.name,
                                        icon: 'icon-user', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    });
                                });

                                // 
                                if (environment.firebase.projectId === 'scuole-poschiavo-5fs67dx6d') {
                                    route.submenu.push({
                                        path: '/settings/students',
                                        title: 'Students',
                                        icon: 'icon-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    })
                                    route.submenu.push({
                                        path: '/settings/students-poschiavo',
                                        title: 'Students w/o birthdate',
                                        icon: 'icon-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    })
                                    route.submenu.push({
                                        path: '/settings/students-poschiavo-check',
                                        title: 'Students w/o birthdate check',
                                        icon: 'icon-list', class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                    })
                                }

                                routes.push(route);
                            }

                            // const params = new HttpParams();
                            const isAdminOrTeacher = this.currentUser && (this.currentUser.isAdmin || (this.currentUser.isTeacher && this.currentUser.isTeacher()));

                            this.loading = true;
                            this.groupService.getAll(params).subscribe(groups => {
                                this.groups = groups;

                                this.loading = false;

                                _.forEach(routes, (route) => {
                                    if (route.path === '/classes') {
                                        route.submenu = [];
                                        const classesAdded = new Map();
                                        _.forEach(this.groups, (group) => {
                                            if (!classesAdded.has(group.id)) {
                                                classesAdded.set(group.id, 'true')
                                                const classRoute = {
                                                    path: '',
                                                    title: group.name,
                                                    icon: group.isGroup ? 'fa fa-users' : 'fa fa-graduation-cap',
                                                    class: 'has-sub', badge: isAdminOrTeacher ? group.userTotalCount : '',
                                                        badgeClass: 'badge-group-count', isExternalLink: false,
                                                    submenu: [
                                                        /* {
                                                            path: '/classes/' + group.id + '/categories',
                                                            title: 'categories',
                                                            icon: 'icon-pin', class: '', badge: '',
                                                                badgeClass: '', isExternalLink: false, submenu: []
                                                        }, */
                                                        /* {
                                                            path: '/classes/' + group.id + '/messages',
                                                            title: 'Nachrichten',
                                                            icon: 'icon-envelope',
                                                            class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                                        }, */
                                                        /* {
                                                            path: '/classes/' + group.id + '/forms',
                                                            title: 'Formulareinträge',
                                                            icon: 'icon-check', class: '', badge: '',
                                                                badgeClass: '', isExternalLink: false, submenu: []
                                                        }, */
                                                    ]
                                                };

                                                let seeAdditionalItems = this.globalService.currentUser.isAdmin;
                                                if (!seeAdditionalItems && this.currentUser.groups && this.currentUser.groups.length) {
                                                    if (this.globalService.currentUser.role.type === 'teacher' || this.globalService.currentUser.role.type === 'admin') {
                                                        this.currentUser.groups.forEach((item: any) => {
                                                            if (item.id === group.id && item.active) {
                                                                seeAdditionalItems = true;
                                                            }
                                                        })
                                                    }
                                                }

                                                if (!seeAdditionalItems && this.currentUser.rights && this.currentUser.rights.length) {
                                                    this.currentUser.rights.forEach((right) => {
                                                        if (right.group.id === group.id && right.role.type === 'teacher') {
                                                            seeAdditionalItems = true;
                                                        }
                                                    })
                                                }
                                                
                                                if (this.currentUser.canGroup && this.currentUser.canGroup('dontShowCategories', group.id) === false) {
                                                    classRoute.submenu.push({
                                                        path: '/classes/' + group.id + '/categories',
                                                        title: 'categories',
                                                        icon: 'icon-pin', class: '', badge: '',
                                                            badgeClass: '', isExternalLink: false, submenu: []
                                                    });
                                                }

                                                if (seeAdditionalItems) {
                                                    if (!this.settings.classBookDisabled) {
                                                        classRoute.submenu.push({
                                                            path: '/classes/' + group.id + '/classbook',
                                                            title: 'classBook',
                                                            icon: 'icon-book-open', class: '', badge: '',
                                                                badgeClass: '', isExternalLink: false, submenu: []
                                                        });
                                                    }

                                                    classRoute.submenu.push({
                                                        path: '/classes/' + group.id + '/absences',
                                                        title: 'absence-calendar',
                                                        icon: 'icon-calendar', class: '', badge: '',
                                                            badgeClass: '', isExternalLink: false, submenu: []
                                                    });

                                                    classRoute.submenu.push({
                                                        path: '/classes/' + group.id + '/students',
                                                        title: 'student-list',
                                                        icon: 'fa fa-graduation-cap', class: '', badge: '',
                                                            badgeClass: '', isExternalLink: false, submenu: []
                                                    });

                                                    classRoute.submenu.push({
                                                        path: '/classes/' + group.id + '/users',
                                                        title: 'all_users',
                                                        icon: 'icon-users',
                                                        class: '', badge: '', badgeClass: '', isExternalLink: false, submenu: []
                                                    });
                                                    _.forEach(this.roles, (role) => {
                                                        const showRole = _.find(group.deactivatedRoles, (tmpRole) => {
                                                            return tmpRole.id === role.id;
                                                        }) === undefined;
                                                        if (!role.invisibleInClass && showRole) {
                                                            const groupRole = group.roles.find((item) => item.id === role.id)
                                                            if (groupRole && groupRole.count) {
                                                                classRoute.submenu.push({
                                                                    path: '/classes/' + group.id + '/usersbyrole/' + role.id + '/users',
                                                                    title: role.name,
                                                                    icon: 'icon-user',
                                                                    class: '',
                                                                    badge: isAdminOrTeacher ? groupRole.count : '',
                                                                        badgeClass: 'badge-user-count', isExternalLink: false, submenu: []
                                                                });
                                                            }
                                                        }
                                                    });
                                                }

                                                // special rule for brusio
                                                let customRuleActive = false;
                                                if (this.currentUser.role) {
                                                    if (group.id === "v4xIONQjhV5lZQGPHBEI" && this.currentUser.role.name === "Direzione scolastica") {
                                                        customRuleActive = true;
                                                    }
                                                }

                                                if (!customRuleActive) {
                                                    route.submenu.push(classRoute);
                                                }
                                            }
                                        });
                                    }

                                });

                                this.menuItems = routes;
                            });
                        });
                    });
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts